export default __webpack_public_path__ + "static/media/ic_germany.92baac0b.svg";